/**
 * This is a special parameter that we use to identify what campaign should be opened in the modal.
 * This is NOT a pass-through parameter expected by the app
 */
export const CAMPAIGN_PARAM = 'campaign'

// donation parameters
export const RECURRING_PARAM = 'recurring' // TODO @hvnt: this should be 'frequency'... we did recurring for EG2
export const FREQUENCY_PARAM = 'frequency'
export const AMOUNT_PARAM = 'amount'
export const PRESET1_PARAM = 'preset1'
export const PRESET2_PARAM = 'preset2'
export const PRESET3_PARAM = 'preset3'
export const PRESET4_PARAM = 'preset4'
export const CURRENCY_PARAM = 'currency'

// donor parameters
export const FIRST = 'first'
export const LAST = 'last'
export const EMAIL = 'email'
export const PHONE = 'phone'
export const STREET = 'street'
export const CITY = 'city'
export const STATE = 'state'
export const ZIP = 'zip'
export const COUNTRY = 'country'

export const DONOR_PARAMS = [FIRST, LAST, EMAIL, PHONE, STREET, CITY, STATE, ZIP, COUNTRY]

// tracking parameters
/**
 * PS. Not really a parameter. Only communicates that there may be multiple params with name utm_*
 */
export const UTM_PARAM = 'utm_*'
export const C_SRC_PARAM = 'c_src'
export const C_SRC2_PARAM = 'c_src2'

// options parameters
export const DESIGNATION_PARAM = 'designation'
export const DEDICATION_PARAM = 'dedication'
export const DEDICATION_TYPE_PARAM = 'dedicationType'
export const RECURRING_END_DATE_PARAM = 'recurringEndDate'

// abandoned-cart recovery parameters
/**
 * Secure recovery token from a reminder-email link. Passed through to the
 * embedded app, which exchanges it to rehydrate the abandoned checkout.
 */
export const RECOVERY_TOKEN_PARAM = 'recovery_token'
/** Action attached to a recovery link, currently `unsubscribe`. */
export const CART_RECOVERY_ACTION_PARAM = 'cart_recovery_action'

// parameters that the org. can pass via the url
export const CLASSY_PARAMS = [
  RECURRING_PARAM,
  FREQUENCY_PARAM,
  RECURRING_END_DATE_PARAM,
  AMOUNT_PARAM,
  PRESET1_PARAM,
  PRESET2_PARAM,
  PRESET3_PARAM,
  PRESET4_PARAM,
  CURRENCY_PARAM,
  UTM_PARAM,
  C_SRC_PARAM,
  C_SRC2_PARAM,
  DESIGNATION_PARAM,
  DEDICATION_PARAM,
  RECOVERY_TOKEN_PARAM,
  CART_RECOVERY_ACTION_PARAM,
  DEDICATION_TYPE_PARAM,
  ...DONOR_PARAMS,
]
